import budgetService from "../../services/budget/budget";
import { BudgetState } from "./states/budget.state.interface";
import { Budget } from "../../services/budget/entities/budget.interface";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    budgets: [],
    totalBudgets: 0
  },
  getters: {
    getBudgets: (state: BudgetState) => state.budgets,
    getTotalBudgets: (state: BudgetState) => state.totalBudgets
  },
  mutations: {
    setBudgets(state: BudgetState, budgets: Array<Budget>) {
      Vue.set(state, "budgets", budgets);
    },
    setTotalBudgets(state: BudgetState, totalBudgets: number) {
      Vue.set(state, "totalBudgets", totalBudgets);
    }
  },
  actions: {
    generateBudget: async (context: any, payload: any) => {
      let created = false;
      await budgetService
        .generateBudget(payload)
        .then(async (response: any) => {
          created = response.data.created;
        });
      return created;
    },
    getBudgets: async (context: any, payload: any) => {
      context.commit("setBudgets", []);
      await budgetService.getBudgets(payload).then((response: any) => {
        context.commit("setTotalBudgets", response.data.totalBudgets);
        context.commit("setBudgets", response.data.budgets);
      });
    }
  }
};
